export default __webpack_public_path__ + "static/media/illustration-recruit-2-m.b5bda2a6.webp";